// API Configuration
// Dev CRA (:3000) and peppar-storefront (:3002) talk to Tomcat.
// Production (nginx same origin) uses relative /api paths.
function resolveApiBaseUrl(): string {
  if (typeof window === 'undefined') {
    return process.env.API_PROXY_TARGET || 'http://127.0.0.1:8080';
  }
  const { hostname, port } = window.location;
  const isLocalDevHost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isLocalSpaPort = port === '3000' || port === '3002';
  if (isLocalDevHost && isLocalSpaPort) {
    return process.env.REACT_APP_API_URL || 'http://localhost:8080';
  }
  return '';
}

function isLocalSpaDevHost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const { hostname, port } = window.location;
  const isLocalDevHost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isLocalSpaPort = port === '3000' || port === '3002';
  return isLocalDevHost && isLocalSpaPort;
}

/** Tomcat origin for REST API calls. */
export function resolveBackendOrigin(): string {
  const base = resolveApiBaseUrl();
  if (base) {
    return base.replace(/\/$/, '');
  }
  if (typeof window === 'undefined') {
    return 'http://127.0.0.1:8080';
  }
  return `${window.location.protocol}//${window.location.host}`;
}

/**
 * Origin for CometD and /resources scripts.
 * Local CRA uses setupProxy.js so CometD stays same-origin (avoids cross-origin long-poll).
 */
export function resolveCometOrigin(): string {
  if (isLocalSpaDevHost()) {
    return `${window.location.protocol}//${window.location.host}`;
  }
  return resolveBackendOrigin();
}

/** Same-origin first (dev proxy), then Tomcat — storefront HPM can drop the /resources prefix. */
export function resolveCometScriptUrls(path: string): string[] {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const sameOrigin = resolveCometOrigin().replace(/\/$/, '');
  const backend = resolveBackendOrigin().replace(/\/$/, '');
  const urls = [`${sameOrigin}${normalized}`];
  if (backend && backend !== sameOrigin) {
    urls.push(`${backend}${normalized}`);
  }
  return urls;
}

export const API_CONFIG = {
  baseURL: resolveApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export default API_CONFIG;
